"use strict";
exports.__esModule = true;
exports.getTimeFromISODate = exports.getDateFromISODate = exports.getISODateFromDateTime = exports.convert24HourTo12Hour = exports.convert12to24hour = exports.isValidDate = void 0;
var constants_1 = require("./constants");
var types_1 = require("./types");
exports.isValidDate = function (dateTime) {
    return !!Date.parse(dateTime);
};
/**
 * Converts 12 hour format to 24 hour format
 * Example: 11 PM returns 23
 * @param hour
 * @param period
 */
exports.convert12to24hour = function (hour, period) {
    // The date here doesn't matter but is required
    return new Date("01/01/2020 " + hour + ":00 " + period).getHours();
};
/**
 * Converts a 24 hour format to a 12 hour format
 * Handles assigning the correct period
 * @param hour
 * @param minute
 * @returns Time type
 */
exports.convert24HourTo12Hour = function (hour, minute) {
    var strMinute = minute ? minute.toString() : '0';
    // The date here doesn't matter but is required
    var dateTime = new Date("01/01/2020 " + hour + ":" + strMinute);
    var options = {
        hour: 'numeric',
        minute: 'numeric'
    };
    var _a = dateTime
        .toLocaleTimeString('en-us', options)
        .split(':'), hr = _a[0], minPeriod = _a[1];
    var _b = minPeriod.split(' '), min = _b[0], period = _b[1];
    // parseInt then toString is to trim leading 0's
    // The TimeField component doesn't accept them
    return {
        hour: parseInt(hr, 10).toString(),
        minute: parseInt(min, 10).toString(),
        period: types_1.Periods[period]
    };
};
/**
 * Assembles an ISO 8601 date
 * Accepts a date in your local time zone and results in a date
 * in an ISO 8601 format / UTC
 * @param date string in format of MM/DD/YYYY
 * @param time
 */
exports.getISODateFromDateTime = function (date, time) {
    if (time.hour === '' ||
        time.minute === '' ||
        time.period === '' ||
        !exports.isValidDate(date) ||
        date.length !== constants_1.REQUIRED_DATE_LENGTH) {
        return '';
    }
    var dateObj = new Date(date);
    var dd = dateObj.getDate();
    var mm = dateObj.getMonth() + 1;
    var yyyy = dateObj.getFullYear();
    var hour = exports.convert12to24hour(parseInt(time.hour, 10), time.period);
    var minute = parseInt(time.minute, 10);
    return new Date(mm + "/" + dd + "/" + yyyy + " " + hour + ":" + minute + ":00").toISOString();
};
// take a ISO string date and returns a date i.e. '22/22/2222'
exports.getDateFromISODate = function (dateTime) {
    var date = new Date(dateTime);
    var dd = date
        .getDate()
        .toString()
        .padStart(2, '0');
    var mm = (date.getMonth() + 1).toString().padStart(2, '0');
    var yyyy = date.getFullYear();
    return mm + "/" + dd + "/" + yyyy;
};
// take a ISO string date and returns a Time
exports.getTimeFromISODate = function (dateTime) {
    var date = new Date(dateTime);
    var hour = date.getHours();
    var minute = date.getMinutes();
    return exports.convert24HourTo12Hour(hour, minute);
};
